<template>
  <div class="col-12">
    <b-card no-body style="background-color: #f3f3f4">
      <b-tabs card fill v-model="tabIndex">
        <b-tab title="Global" :active="tabIndex === 0">
          <div class="row">
            <div class="form-group col-lg-6">
              <label for="origin">{{ $t("origin") }}</label>
              <Combobox
                class="bg-white"
                name="origin"
                :placeholder="$t('select_a_item')"
                :hasErrors="errors.has('origin')"
                :options="origins"
                :initial-value="integratorSettings.origin"
                label="nome_origem"
                v-model="integratorSettings.origin"
                :reduce="(origin) => origin.codigo_externo"
                v-validate="'required'"
              />

              <small v-show="errors.has('origin')" class="form-text text-muted">
                {{ errors.first("origin") }}
              </small>
            </div>

            <div class="form-group col-lg-6">
              <label for="driver_groups">{{ $t("driver_groups") }}</label>
              <Combobox
                class="bg-white"
                name="driver_groups"
                :placeholder="$t('select_a_item')"
                :options="driverGroups"
                :initial-value="integratorSettings.driverGroups"
                label="nome_grupo_motorista"
                v-model="integratorSettings.driverGroups"
                :reduce="(driverGroup) => driverGroup.id"
                multiple
              />
            </div>

            <div
              class="form-group col-lg-6"
              :class="{ 'has-error': errors.has('endpointDeliveries') }"
            >
              <label for="endpointDeliveries">{{
                $t("endpointDeliveries")
              }}</label>
              <input
                type="text"
                id="endpointDeliveries"
                name="endpointDeliveries"
                class="form-control"
                :placeholder="$t('ph_endpoint_deliveries')"
                v-model="integratorSettings.endpointDeliveries"
                v-validate="'required'"
              />

              <small
                v-show="errors.has('endpointDeliveries')"
                class="form-text"
              >
                {{ errors.first("endpointDeliveries") }}
              </small>
            </div>

            <div
              class="form-group col-lg-6"
              :class="{ 'has-error': errors.has('endpointLocalization') }"
            >
              <label for="endpointLocalization">{{
                $t("endpointLocalization")
              }}</label>
              <input
                type="text"
                id="endpointLocalization"
                name="endpointLocalization"
                class="form-control"
                :placeholder="$t('ph_endpoint_localization')"
                v-model="integratorSettings.endpointLocalization"
                v-validate="'required'"
              />

              <small
                v-show="errors.has('endpointLocalization')"
                class="form-text"
              >
                {{ errors.first("endpointLocalization") }}
              </small>
            </div>

            <div
              class="form-group col-lg-6"
              :class="{ 'has-error': errors.has('endpointApiFrotix') }"
            >
              <label for="endpointApiFrotix">{{
                $t("endpointApiFrotix")
              }}</label>
              <input
                type="text"
                id="endpointApiFrotix"
                name="endpointApiFrotix"
                class="form-control"
                :placeholder="$t('ph_endpoint_api_frotix')"
                v-model="integratorSettings.endpointApiFrotix"
                v-validate="'required'"
              />

              <small v-show="errors.has('endpointApiFrotix')" class="form-text">
                {{ errors.first("endpointApiFrotix") }}
              </small>
            </div>

            <div
              class="form-group col-lg-6"
              :class="{ 'has-error': errors.has('endpointApiMongo') }"
            >
              <label for="endpointApiMongo">{{ $t("endpointApiMongo") }}</label>
              <input
                type="text"
                id="endpointApiMongo"
                name="endpointApiMongo"
                class="form-control"
                :placeholder="$t('ph_endpoint_api_frotix')"
                v-model="integratorSettings.endpointApiMongo"
                v-validate="'required'"
              />

              <small v-show="errors.has('endpointApiMongo')" class="form-text">
                {{ errors.first("endpointApiMongo") }}
              </small>
            </div>

            <div class="form-group col-lg-6">
              <label for="routeName">{{ $t("routeName") }}</label>
              <Combobox
                multiple
                class="bg-white"
                name="routeName"
                :hasErrors="errors.has('routeName')"
                :placeholder="$t('select_a_item')"
                label="label"
                :options="optionsRouteName"
                :initial-value="integratorSettings.routeName"
                v-model="integratorSettings.routeName"
              />

              <small
                v-show="errors.has('routeName')"
                class="form-text text-muted"
              >
                {{ errors.first("routeName") }}
              </small>
            </div>
          </div>

          <hr />

          <h3>Diretórios XML</h3>

          <div class="row px-2">
            <div
              class="form-group col-lg-4"
              :class="{ 'has-error': errors.has('originDirectory') }"
            >
              <label for="originDirectory">{{ $t("originDirectory") }}</label>
              <input
                type="text"
                id="originDirectory"
                name="originDirectory"
                class="form-control"
                :placeholder="$t('ph_origin_directory')"
                v-validate="'required'"
                v-model="integratorSettings.originDirectory"
              />

              <small v-show="errors.has('originDirectory')" class="form-text">
                {{ errors.first("originDirectory") }}
              </small>
            </div>

            <div
              class="form-group col-lg-4"
              :class="{ 'has-error': errors.has('destinyDirectory') }"
            >
              <label for="destinyDirectory">{{ $t("destinyDirectory") }}</label>
              <input
                type="text"
                id="destinyDirectory"
                name="destinyDirectory"
                class="form-control"
                :placeholder="$t('ph_destiny_directory')"
                v-validate="'required'"
                v-model="integratorSettings.destinyDirectory"
              />

              <small v-show="errors.has('destinyDirectory')" class="form-text">
                {{ errors.first("destinyDirectory") }}
              </small>
            </div>

            <div
              class="form-group col-lg-4"
              :class="{ 'has-error': errors.has('sendedDirectory') }"
            >
              <label for="sendedDirectory">{{ $t("sendedDirectory") }}</label>
              <input
                type="text"
                id="sendedDirectory"
                name="sendedDirectory"
                class="form-control"
                :placeholder="$t('ph_sended_directory')"
                v-validate="'required'"
                v-model="integratorSettings.destinyDirectory"
              />

              <small v-show="errors.has('sendedDirectory')" class="form-text">
                {{ errors.first("sendedDirectory") }}
              </small>
            </div>
          </div>

          <hr />

          <div v-for="(item, index) in switches" :key="index" class="mb-1 ml-3">
            <div class="row align-items-center">
              <b-form-checkbox
                switch
                :id="`checkbox-${index}`"
                :name="`checkbox-${index}`"
                v-model="integratorSettings[item.vModel]"
              >
                {{ item.name }}
              </b-form-checkbox>

              <div
                v-if="item.description"
                class="text-center bg-primary-frotix rounded-circle align-items-center align-content-center ml-2"
                data-toggle="tooltip"
                data-placement="top"
                :title="item.description"
                aria-hidden="false"
                style="height: 25px; width: 25px"
              >
                <i class="fas fa-info" style="color: black" />
              </div>
            </div>

            <div
              v-if="
                item.vModel === 'useItinerary' &&
                integratorSettings[item.vModel]
              "
              class="row ml-4"
            >
              <b-form-checkbox
                switch
                :id="`checkbox-show-poligons`"
                :name="`checkbox-show-poligons`"
                v-model="
                  integratorSettings['showDeliveriesItinerariesPoligons']
                "
              >
                Mostrar Polígonos
              </b-form-checkbox>
            </div>
          </div>
        </b-tab>

        <b-tab title="Módulos" :active="tabIndex === 1">
          <div class="row">
            <div class="form-group col-lg-12">
              <b-form-group label="Módulo" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-2"
                  v-model="moduleConfigValue"
                  :aria-describedby="ariaDescribedby"
                  name="radio-options-2"
                  class="d-flex justify-content-between"
                >
                  <b-form-radio
                    v-for="option in optionsModules"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div
              class="form-group col-lg-12"
              v-if="
                integratorSettings.moduleConfig &&
                integratorSettings.moduleConfig.value === 'microservice'
              "
            >
              <label for="endpoint_microservice">{{
                $t("endpoint_microservice")
              }}</label>
              <input
                type="text"
                id="endpoint_microservice"
                name="endpoint_microservice"
                class="form-control"
                :placeholder="$t('ph_endpoint_microservice')"
                v-model="integratorSettings.moduleConfig.apiurl"
              />
            </div>

            <div
              class="form-group col-lg-12"
              v-if="
                integratorSettings.moduleConfig &&
                integratorSettings.moduleConfig.value === 'spreadsheet'
              "
            >
              <div>
                <b-form-checkbox
                  switch
                  :id="`checkbox-keep-filename`"
                  :name="`checkbox-keep-filename`"
                  v-model="integratorSettings.moduleConfig.keepFilename"
                  class="mb-3"
                >
                  Manter o nome do arquivo
                </b-form-checkbox>

                <b-form-checkbox
                  switch
                  :id="`checkbox-use-one-register-by-lote`"
                  :name="`checkbox-use-one-register-by-lote`"
                  v-model="integratorSettings.moduleConfig.useOneRegisterByLote"
                >
                  Usar 1 (um) registro por lote
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </b-tab>

        <b-tab title="Janela" :active="tabIndex === 2">
          <div class="row">
            <div class="col-lg-6 mt-2 px-1">
              <div class="border rounded py-2 px-4 h-100 bg-white shadow-sm">
                <h3>Horário de Almoço</h3>

                <div class="row mt-4">
                  <div
                    class="form-group col-lg-4"
                    :class="{ 'has-error': errors.has('start_lunch') }"
                  >
                    <label for="start_lunch">Início</label>
                    <input
                      type="time"
                      id="start_lunch"
                      name="start_lunch"
                      class="form-control"
                      :placeholder="$t('ph_start')"
                      v-model="
                        integratorSettings.windowConfig.breakWindow.start
                      "
                      v-validate="'required'"
                    />

                    <small v-show="errors.has('start_lunch')" class="form-text">
                      {{ errors.first("start_lunch") }}
                    </small>
                  </div>

                  <div
                    class="form-group col-lg-4"
                    :class="{ 'has-error': errors.has('end_lunch') }"
                  >
                    <label for="end_lunch">{{ $t("end") }}</label>
                    <input
                      type="time"
                      id="end_lunch"
                      name="end_lunch"
                      class="form-control"
                      :placeholder="$t('ph_end')"
                      v-model="integratorSettings.windowConfig.breakWindow.end"
                      v-validate="'required'"
                    />

                    <small v-show="errors.has('end_lunch')" class="form-text">
                      {{ errors.first("end_lunch") }}
                    </small>
                  </div>

                  <div
                    class="form-group col-lg-4"
                    :class="{ 'has-error': errors.has('duration_lunch') }"
                  >
                    <label for="duration_lunch"
                      >{{ $t("duration") }} (minutos)</label
                    >
                    <input
                      type="number"
                      id="duration_lunch"
                      name="duration_lunch"
                      class="form-control"
                      :placeholder="$t('ph_duration')"
                      v-model="breakWindowTime"
                      v-validate="'required'"
                    />

                    <small
                      v-show="errors.has('duration_lunch')"
                      class="form-text"
                    >
                      {{ errors.first("duration_lunch") }}
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6 mt-2 px-1">
              <div class="border rounded py-2 px-4 h-100 bg-white shadow-sm">
                <h3>Tempo de Entrega</h3>

                <div class="row mt-4">
                  <div class="form-group col-lg-6">
                    <label for="type">{{ $t("type") }}</label>
                    <Combobox
                      class="bg-white"
                      name="type"
                      :placeholder="$t('select_a_item')"
                      :hasErrors="errors.has('type')"
                      :options="timeTypes"
                      :initial-value="
                        integratorSettings.windowConfig.serviceTimeType
                      "
                      label="text"
                      v-model="integratorSettings.windowConfig.serviceTimeType"
                      :reduce="(type) => type.value"
                    />
                  </div>

                  <div class="form-group col-lg-6">
                    <label for="duration_service_time"
                      >{{ $t("duration") }} ({{
                        integratorSettings.windowConfig.serviceTimeType ===
                        "fixed_time"
                          ? "minutos"
                          : "segundos"
                      }})</label
                    >
                    <input
                      type="number"
                      id="duration_service_time"
                      name="duration_service_time"
                      class="form-control"
                      :placeholder="$t('ph_duration')"
                      v-model="serviceTime"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 mt-2 px-1">
              <div class="border rounded py-2 px-4 h-100 bg-white shadow-sm">
                <h3 style="margin-bottom: 24px">Horários de Expediente</h3>

                <div
                  class="row align-items-center"
                  v-for="(day, index) in days"
                  :key="index"
                >
                  <div class="col-lg-4">
                    <span>{{ day.name }}:</span>
                  </div>

                  <div
                    class="form-group col-lg-4"
                    :class="{
                      'has-error': errors.has(
                        `start_delivery_day_${day.value}`
                      ),
                    }"
                  >
                    <label :for="`start_delivery_day_${day.value}`"
                      >Início</label
                    >
                    <input
                      type="time"
                      :id="`start_delivery_day_${day.value}`"
                      :name="`start_delivery_day_${day.value}`"
                      class="form-control"
                      :placeholder="$t('ph_start')"
                      v-model="
                        integratorSettings.windowConfig.deliveryDays[day.value]
                          .start
                      "
                    />

                    <small
                      v-show="errors.has(`start_delivery_day_${day.value}`)"
                      class="form-text"
                    >
                      {{ errors.first(`start_delivery_day_${day.value}`) }}
                    </small>
                  </div>

                  <div
                    class="form-group col-lg-4"
                    :class="{
                      'has-error': errors.has(`end_delivery_day_${day.value}`),
                    }"
                  >
                    <label :for="`end_delivery_day_${day.value}`">{{
                      $t("end")
                    }}</label>
                    <input
                      type="time"
                      :id="`end_delivery_day_${day.value}`"
                      :name="`end_delivery_day_${day.value}`"
                      class="form-control"
                      :placeholder="$t('ph_end')"
                      v-model="
                        integratorSettings.windowConfig.deliveryDays[day.value]
                          .end
                      "
                    />

                    <small
                      v-show="errors.has(`end_delivery_day_${day.value}`)"
                      class="form-text"
                    >
                      {{ errors.first(`end_delivery_day_${day.value}`) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6 mt-2 px-1">
              <div class="border rounded py-2 px-4 h-100 bg-white shadow-sm">
                <h3 style="margin-bottom: 24px">Horários de Recebimento</h3>

                <div
                  class="row align-items-center"
                  v-for="(day, index) in days"
                  :key="index"
                >
                  <div class="col-lg-4">
                    <span>{{ day.name }}:</span>
                  </div>

                  <div
                    class="form-group col-lg-4"
                    :class="{
                      'has-error': errors.has(
                        `start_receipt_time_${day.value}`
                      ),
                    }"
                  >
                    <label :for="`start_receipt_time_${day.value}`"
                      >Início</label
                    >
                    <input
                      type="time"
                      :id="`start_receipt_time_${day.value}`"
                      :name="`start_receipt_time_${day.value}`"
                      class="form-control"
                      :placeholder="$t('ph_start')"
                      v-model="
                        integratorSettings.windowConfig.defaultReceiptTimes[
                          day.value
                        ].start
                      "
                    />

                    <small
                      v-show="errors.has(`start_receipt_time_${day.value}`)"
                      class="form-text"
                    >
                      {{ errors.first(`start_receipt_time_${day.value}`) }}
                    </small>
                  </div>

                  <div
                    class="form-group col-lg-4"
                    :class="{
                      'has-error': errors.has(`end_receipt_time_${day.value}`),
                    }"
                  >
                    <label :for="`end_receipt_time_${day.value}`">{{
                      $t("end")
                    }}</label>
                    <input
                      type="time"
                      :id="`end_receipt_time_${day.value}`"
                      :name="`end_receipt_time_${day.value}`"
                      class="form-control"
                      :placeholder="$t('ph_end')"
                      v-model="
                        integratorSettings.windowConfig.defaultReceiptTimes[
                          day.value
                        ].end
                      "
                    />

                    <small
                      v-show="errors.has(`end_receipt_time_${day.value}`)"
                      class="form-text"
                    >
                      {{ errors.first(`end_receipt_time_${day.value}`) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>

    <div class="col-12 mt-3 px-0" style="justify-items: flex-end">
      <div class="row mr-1">
        <button
          type="button"
          class="btn btn-outline-danger block m-b mr-2"
          @click="showModalErrors"
          v-if="errorsMessage.length"
        >
          <i class="fas fa-exclamation-triangle mr-2" />

          Ver erros
        </button>

        <LoaderButton @click="save">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>

    <!-- MODAL ERRORS -->
    <div
      ref="modalErrors"
      id="modalErrors"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalErrors"
      aria-hidden="true"
    >
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalErrorsLabel">Erros</h5>
          </div>

          <div class="modal-body">
            <ul>
              <li v-for="error in errorsMessage" :key="error">
                {{ error }}
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <b-button class="mt-3" id="closeModal" data-dismiss="modal">
              {{ $t("close") }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import { mapState } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
  name: "Integrator",
  components: {
    LoaderButton,
    Combobox,
  },

  data() {
    return {
      tabIndex: 0,
      switches: [
        { name: "Atualizar automaticamente", vModel: "autoUpdate" },
        { name: "Gerar lote automático", vModel: "generateLoteAutomatic" },
        { name: "Criar 1 (um) lote por UF", vModel: "createOneLoteByUF" },
        {
          name: "Manter o lote quando o percurso contemplar todas as entregas em um único veículo",
          vModel: "keepLoteWhenAllDeliveriesInOneVehicle",
        },
        { name: "Ocultar seleção de motorista", vModel: "hideDriverSelection" },
        { name: "Obrigatório seleção de motorista", vModel: "driverRequired" },
        {
          name: "Não agrupar entregas apara o mesmo endereço",
          vModel: "noGroupDeliveriesSameAddress",
        },
        {
          name: "Agrupar entregas por origem quado enviar ao Frotix",
          vModel: "groupDeliveriesByOriginWhenSendToFrotix",
        },
        { name: "Utilizar roteiros", vModel: "useItinerary" },
        {
          name: "Utilizar coordenadas como prioridade",
          vModel: "useCoordinatesAsPriority",
        },
        {
          name: "Utilizar hash para endereço do cliente",
          vModel: "useHashForClientAddress",
          description:
            "Esta opção cria um hash para o endereço do cliente no ERP e permite vincular a um endereço na plataforma Frotix (igual ou não) que será utilizado nas próximas roteirizações.",
        },
        {
          name: "Manter posição existente (entrega)",
          vModel: "keepPositionExistingDelivery",
          description:
            "Esta opção serve para definir a posição da entrega com o valor já existente (SE existir) ao importar.",
        },
        {
          name: "Carregar veículos de acordo com a Data Prevista Saída",
          vModel: "loadVehiclesAccordingToEstimatedDepartureDate",
        },
        { name: "Enviar lote sem veículo", vModel: "sendLoteWithoutVehicle" },
        {
          name: "Vincular veículo à entrega automaticamente",
          vModel: "linkVehicleToDeliveryAutomatically",
        },
        { name: "Mostrar Mini Anel Viário SP", vModel: "showMiniAnelViarioSP" },
        { name: "Logs", vModel: "logs" },
        { name: "Mostrar lotes em aberto", vModel: "showLotesOpened" },
        { name: "Mostrar Área Máxima SP ▲", vModel: "showMaxAreaSP" },
      ],
      clientSelected: null,
      userSelected: null,
      changeBy: "company",
      optionsModules: [
        { value: "sigecloud", text: "Sige Cloud" },
        { value: "argos", text: "Argos" },
        { value: "alterdata", text: "Alter Data" },
        { value: "nfe", text: "NF-e" },
        { value: "rotasCsv", text: "Rotas CSV" },
        { value: "mdfe", text: "MDF-e" },
        { value: "cte", text: "CT-e" },
        { value: "cissPoder", text: "CISS Poder" },
        {
          value: "microservice",
          text: "Micro serviço Frotix",
          apiurl: "http://localhost:8082/api/v2/",
        },
        {
          value: "spreadsheet",
          text: "Planilha Excel",
          keepFilename: false,
          useOneRegisterByLote: false,
        },
        { value: "none", text: "Nenhum" },
      ],
      days: [
        { name: "Segunda", value: "monday", start: "08:00", end: "18:00" },
        { name: "Terça", value: "tuesday", start: "08:00", end: "18:00" },
        { name: "Quarta", value: "wednesday", start: "08:00", end: "18:00" },
        { name: "Quinta", value: "thursday", start: "08:00", end: "18:00" },
        { name: "Sexta", value: "friday", start: "08:00", end: "18:00" },
        { name: "Sábado", value: "saturday", start: "08:00", end: "18:00" },
        { name: "Domingo", value: "sunday", start: "08:00", end: "18:00" },
      ],
      timeTypes: [
        { value: "fixed_time", text: "Tempo Fixo" },
        { value: "volume_time", text: "Tempo por Volume" },
        { value: "weight_time", text: "Tempo por Peso" },
      ],
      optionsRouteName: [
        {
          label: "Origem",
          value: "origin",
        },
        {
          label: "Primeira Cidade",
          value: "first_city",
        },
        {
          label: "Última Cidade",
          value: "last_city",
        },
        {
          label: "Destino",
          value: "destiny",
        },
        {
          label: "Agrupamento da Primeira Entrega",
          value: "grouping_first_delivery",
        },
      ],
      errorsMessage: [],
    };
  },

  computed: {
    ...mapState({
      origins: (state) => state.origin.all,
      driverGroups: (state) => state.drivergroups.all,
    }),

    integratorSettings: {
      get() {
        return this.$store.state.integrator.settingsById;
      },

      set(value) {
        this.$store.commit("integrator/setIntegratorSettingsById", value);
      },
    },

    breakWindowTime: {
      get() {
        return (
          _.get(this.integratorSettings, "windowConfig.breakWindow.time", 0) /
          60
        );
      },

      set(value) {
        this.integratorSettings.windowConfig.breakWindow.time = value * 60;
      },
    },

    serviceTime: {
      get() {
        const value = this.integratorSettings.windowConfig.serviceTime;

        if (
          this.integratorSettings.windowConfig.serviceTimeType === "fixed_time"
        ) {
          const minutes = value / 60;

          return minutes < 1 ? 1 : minutes;
        }

        return value * 1;
      },
      set(value) {
        this.integratorSettings.windowConfig.serviceTime =
          this.integratorSettings.windowConfig.serviceTimeType === "fixed_time"
            ? value * 60
            : value * 1;
      },
    },

    moduleConfigValue: {
      get() {
        // Retorna apenas o 'value' do objeto moduleConfig, que é o que o radio group precisa.
        return this.integratorSettings.moduleConfig
          ? this.integratorSettings.moduleConfig.value
          : null;
      },
      set(newValue) {
        // Quando um novo rádio é selecionado, `newValue` é o valor primitivo (ex: 'microservice').
        const selectedOption = this.optionsModules.find(
          (opt) => opt.value === newValue
        );

        if (selectedOption) {
          const newSettings = {
            ...this.integratorSettings,
            // Atualiza o objeto moduleConfig no estado com uma cópia da opção selecionada.
            moduleConfig: { ...selectedOption },
          };
          // Usa o setter principal para comitar a alteração para o Vuex.
          this.integratorSettings = newSettings;
        }
      },
    },
  },

  methods: {
    async save(evt, done) {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        const err = new Error(this.$t("invalid_form_fields"));
        this.$store.dispatch("notify/error", err);
        return;
      }

      this.errorsMessage = [];
      const errors = [];

      for (const [key, value] of Object.entries(this.integratorSettings)) {
        if (key === "origin" && !value) {
          errors.push("Origem não informada/inválida!");
        }

        if (
          key === "moduleConfig" &&
          value.value === "microservice" &&
          !value.apiurl
        ) {
          errors.push("Informe o Endpoint Microserviço.");
        }

        if (key === "windowConfig") {
          if (!value.breakWindow.start || !value.breakWindow.end) {
            errors.push("Informe o início e fim do horário de almoço.");
          }

          if (value.breakWindow.start && value.breakWindow.end) {
            const start = moment(value.breakWindow.start, "HH:mm");
            const end = moment(value.breakWindow.end, "HH:mm");

            if (end.isBefore(start)) {
              errors.push(
                "O horário de fim do almoço não pode ser anterior ao horário de início."
              );
            }
          }

          if (value.breakWindow.time <= 0) {
            errors.push("O tempo de almoço deve ser maior que 0.");
          }

          if (!value.serviceTimeType) {
            errors.push("Informe o tipo de tempo de entrega.");
          }

          if (value.serviceTime <= 0) {
            this.serviceTime = 1;
          }

          for (const day of this.days) {
            const { start: startDeliveryDay, end: endDeliveryDay } =
              this.integratorSettings.windowConfig.deliveryDays[day.value];

            const { start: startReceiptTime, end: endReceiptTime } =
              this.integratorSettings.windowConfig.defaultReceiptTimes[
                day.value
              ];

            const startDeliveryDayMoment = moment(startDeliveryDay, "HH:mm");
            const endDeliveryDayMoment = moment(endDeliveryDay, "HH:mm");

            const startReceiptTimeMoment = moment(startReceiptTime, "HH:mm");
            const endReceiptTimeMoment = moment(endReceiptTime, "HH:mm");

            if (
              endDeliveryDayMoment.isBefore(startDeliveryDayMoment) ||
              endReceiptTimeMoment.isBefore(startReceiptTimeMoment)
            ) {
              errors.push(`Horário inválido para ${day.name}`);

              continue;
            }

            const existDeliveryDay = startDeliveryDay && endDeliveryDay;
            const existReceiptTime = startReceiptTime && endReceiptTime;

            if (existDeliveryDay != existReceiptTime) {
              errors.push(
                `Se informado Horário de Expediente, deve ser informado também Horário de Recebimento e/ou vice-versa. Verifique para ${day.name}.`
              );
            }
          }
        }

        if (key === "routeName" && !value.length) {
          this.integratorSettings.routeName = this.optionsRouteName;
        }
      }

      if (
        this.integratorSettings.driverRequired &&
        this.integratorSettings.hideDriverSelection
      ) {
        errors.push(
          'Não é possível habilitar as opções "Ocultar seleção de motorista" e "Obrigatório seleção de motorista" ao mesmo tempo'
        );
      }

      if (errors.length) {
        this.errorsMessage = errors;

        return $("#modalErrors").modal("show");
      }

      const { id, ...rest } = this.integratorSettings;

      const updated = await this.$store.dispatch("integrator/edit", {
        id,
        data: rest,
      });

      if (updated) {
        this.$router.push({ name: "listintegratorsettings" });
      }
    },

    showModalErrors() {
      $("#modalErrors").modal("show");
    },
  },
};
</script>

<style>
.nav-link {
  color: black !important;
}

.onoffswitch {
  position: relative;
  width: 60px;
  height: 30px; /* define uma altura fixa */
  display: inline-block;
  vertical-align: middle;
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #e3e3e3;
  border-radius: 30px;
  height: 100%;
}

.onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
  background-color: #ffc107;
  color: white;
  text-align: center;
  line-height: 30px; /* igual à altura */
  font-weight: bold;
}

.onoffswitch-switch {
  display: block;
  width: 30px;
  height: 30px;
  margin: 0;
  background: white;
  position: absolute;
  top: 0;
  right: 30px;
  border: 2px solid #e3e3e3;
  border-radius: 30px;
  transition: all 0.3s ease-in 0s;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0;
}
</style>
